export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl p-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">
          Privacy Policy
        </h1>

        <p className="text-gray-600 mb-8">
          Last Updated: June 2026
        </p>

        <div className="space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold mb-3">
              1. Introduction
            </h2>
            <p>
              DBSkills Attendance respects your privacy and is committed to
              protecting your personal information. This Privacy Policy explains
              how we collect, use, and protect information when you use our
              application.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              2. Information We Collect
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Employee Name</li>
              <li>Email Address / Login Credentials</li>
              <li>Attendance Records</li>
              <li>Location Data (GPS)</li>
              <li>Device Information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              3. How We Use Information
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Manage employee attendance records</li>
              <li>Verify attendance location</li>
              <li>Generate attendance reports</li>
              <li>Improve application performance</li>
              <li>Provide user support</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              4. Location Data
            </h2>
            <p>
              The application collects location information only when users mark
              attendance. This information is used solely for attendance
              verification and reporting purposes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              5. Data Sharing
            </h2>
            <p>
              DBSkills does not sell, rent, or trade personal information with
              third parties. Data may only be shared when required by law or to
              provide essential services related to the application.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              6. Data Security
            </h2>
            <p>
              We implement appropriate security measures to protect user data
              from unauthorized access, alteration, disclosure, or destruction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              7. User Rights
            </h2>
            <p>
              Users may request access, correction, or deletion of their
              personal information by contacting us.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              8. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy periodically. Changes will be
              posted on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">
              9. Contact Us
            </h2>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p><strong>DBSkills</strong></p>
              <p>Email: contactus@dbskills.com</p>
              <p>Website: https://dbskills.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}